import { useState, useEffect, useRef } from "react";
import { Button, DatePicker, Input, Modal, Space } from "antd";
import {
  FileExcelOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { getCollectionsReceiptsForAdmin } from "Network";
import { toastError } from "helpers/toasters";
import {
  exportDataAsExcel,
  handleAllowNumbersOnly,
} from "helpers/helpfulFunctions";

import SubHeader from "../SubComponents/SubHeader";
import GridTable from "modules/SubComponents/GridTable/GridTable";
import Header from "modules/SubComponents/Header";

function ReceivedConfirmation() {
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isExporting, setIsExporting] = useState(false);

  const [creationDateRange, setCreationDateRange] = useState([]);
  const [sellingDateRange, setSellingDateRange] = useState([]);

  const [searchValues, setSearchValues] = useState({
    userName: "",
    userMobile: "",
    type: "",
    quantity: "",
    price: "",
    commission: "",
    totalPriceAfterCommission: "",
    totalPriceBeforeCommission: "",
    from: "",
    to: "",
    sellingDateFrom: "",
    sellingDateTo: "",
    salesPerson: "",
    status: "",
  });

  const { RangePicker } = DatePicker;
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    setLoading(true);

    switch (dataIndex) {
      case "fullName":
        updateSearchValues("userName", selectedKeys[0]);
        break;
      case "phone":
        updateSearchValues("userMobile", selectedKeys[0]);
        break;
      case "categoryName":
        updateSearchValues("type", selectedKeys[0]);
        break;
      case "sealedQuantity":
        updateSearchValues("quantity", selectedKeys[0]);
        break;
      case "offeredPricePerKilo":
        updateSearchValues("price", selectedKeys[0]);
        break;
      case "commission":
        updateSearchValues("commission", selectedKeys[0]);
        break;
      case "totalOfferPriceBeforeCommission":
        updateSearchValues("totalPriceBeforeCommission", selectedKeys[0]);
        break;
      case "totalOfferPriceAfterCommission":
        updateSearchValues("totalPriceAfterCommission", selectedKeys[0]);
        break;
      case "salesPerson":
        updateSearchValues("salesPerson", selectedKeys[0]);
        break;
      default:
        break;
    }

    confirm();
  };

  const handleReset = (clearFilters, dataIndex, confirm) => {
    setLoading(true);

    switch (dataIndex) {
      case "fullName":
        updateSearchValues("userName", "");
        break;
      case "phone":
        updateSearchValues("userMobile", "");
        break;
      case "categoryName":
        updateSearchValues("type", "");
        break;
      case "sealedQuantity":
        updateSearchValues("quantity", "");
        break;
      case "offeredPricePerKilo":
        updateSearchValues("price", "");
        break;
      case "commission":
        updateSearchValues("commission", "");
        break;
      case "totalOfferPriceBeforeCommission":
        updateSearchValues("totalPriceBeforeCommission", "");
        break;
      case "totalOfferPriceAfterCommission":
        updateSearchValues("totalPriceAfterCommission", "");
        break;
      case "salesPerson":
        updateSearchValues("salesPerson", "");
        break;
      default:
        break;
    }

    if (clearFilters) clearFilters();
    if (confirm) confirm();
  };

  const updateSearchValues = (property, newValue, otherProperty) => {
    const copy = { ...searchValues };
    copy[property] = newValue;
    if (otherProperty) {
      copy[otherProperty.property] = otherProperty.value;
    }
    setSearchValues(copy);
  };

  const handleDateChange = (dates, dataIndex) => {
    if (dates) {
      const startDate = dates[0].format("YYYY-MM-DD");
      const endDate = dates[1].format("YYYY-MM-DD");

      if (dataIndex === "creationDate") {
        setCreationDateRange(dates);
        updateSearchValues("from", startDate, {
          property: "to",
          value: endDate,
        });
      } else if (dataIndex === "sellingDate") {
        setSellingDateRange(dates);
        updateSearchValues("sellingDateFrom", startDate, {
          property: "sellingDateTo",
          value: endDate,
        });
      }
    } else {
      if (dataIndex === "creationDate") {
        setCreationDateRange([]);
        updateSearchValues("from", "", {
          property: "to",
          value: "",
        });
      } else if (dataIndex === "sellingDate") {
        setSellingDateRange([]);
        updateSearchValues("sellingDateFrom", "", {
          property: "sellingDateTo",
          value: "",
        });
      }
    }
  };

  // const handleDateChange = (dates, dataIndex) => {
  //   if (dates) {
  //     const startDate = dates[0].format("YYYY-MM-DD");
  //     const endDate = dates[1].format("YYYY-MM-DD");
  //     if (dataIndex === "offerDate" || dataIndex === "creationDate") {
  //       setCreationDateRange(dates);
  //       updateSearchValues("from", startDate, {
  //         property: "to",
  //         value: endDate,
  //       });
  //     } else {
  //       setSellingDateRange(dates);
  //       updateSearchValues("sellingDateFrom", startDate, {
  //         property: "sellingDateTo",
  //         value: endDate,
  //       });
  //     }
  //   } else {
  //     if (dataIndex === "offerDate" || dataIndex === "creationDate") {
  //       updateSearchValues("from", "", { property: "to", value: "" });
  //       setCreationDateRange([]);
  //     } else {
  //       updateSearchValues("sellingDateFrom", "", {
  //         property: "sellingDateTo",
  //         value: "",
  //       });
  //       setSellingDateRange([]);
  //     }
  //   }
  // };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onKeyDown={(e) => {
            const numericFields = [
              "phone",
              "sealedQuantity",
              "commission",
              "totalOfferPriceBeforeCommission",
              "totalOfferPriceAfterCommission",
              "offeredPricePerKilo",
            ];
            if (numericFields.includes(dataIndex))
              handleAllowNumbersOnly(e, true);
          }}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() =>
              clearFilters && handleReset(clearFilters, dataIndex, confirm)
            }
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const getColumnDateProps = (dataIndex) => {
    const dateValue =
      dataIndex === "creationDate" ? creationDateRange : sellingDateRange;
    return {
      filterDropdown: () => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <RangePicker
            value={dateValue}
            onChange={(dates) => handleDateChange(dates, dataIndex)}
          />
        </div>
      ),
      filterIcon: () => (
        <FilterOutlined
          style={dateValue?.length > 0 ? { color: "blue" } : {}}
        />
      ),
      render: (text) => text,
    };
  };

  const columns = [
    {
      key: "fullName",
      title: "NAME",
      dataIndex: "fullName",
      ...getColumnSearchProps("fullName"),
    },
    {
      key: "phone",
      title: "MOBILE",
      dataIndex: "phone",
      ...getColumnSearchProps("phone"),
    },
    {
      key: "categoryName",
      title: "TYPE",
      dataIndex: "categoryName",
      ...getColumnSearchProps("categoryName"),
    },
    {
      key: "sealedQuantity",
      title: "SEALED QTY",
      dataIndex: "sealedQuantity",
      ...getColumnSearchProps("sealedQuantity"),
    },
    {
      key: "offeredPricePerKilo",
      title: "OFFER PRICE",
      dataIndex: "offeredPricePerKilo",
      ...getColumnSearchProps("offeredPricePerKilo"),
    },
    {
      key: "commission",
      title: "COMMISSION",
      dataIndex: "commission",
      ...getColumnSearchProps("commission"),
    },
    {
      key: "totalOfferPriceBeforeCommission",
      title: "TOTAL BEFORE",
      dataIndex: "totalOfferPriceBeforeCommission",
      ...getColumnSearchProps("totalOfferPriceBeforeCommission"),
    },
    {
      key: "totalOfferPriceAfterCommission",
      title: "TOTAL AFTER",
      dataIndex: "totalOfferPriceAfterCommission",
      ...getColumnSearchProps("totalOfferPriceAfterCommission"),
    },
    {
      key: "sellingDate",
      title: "SELLING DATE",
      dataIndex: "sellingDate",
      ...getColumnDateProps("sellingDate"),
    },
    {
      key: "creationDate",
      title: "CREATION DATE",
      dataIndex: "creationDate",
      ...getColumnDateProps("creationDate"),
    },
    {
      key: "status",
      title: "STATUS",
      dataIndex: "status",
      filters: [
        { text: "All", value: "" },
        { text: "Pending", value: 1 },
        { text: "Accepted", value: 2 },
        { text: "Rejected", value: 3 },
      ],
      filteredValue:
        searchValues.status !== "" && searchValues.status !== null
          ? [searchValues.status]
          : null,
      filterMultiple: false,
      onFilter: (value, record) => {
        if (searchValues.status !== value) {
          setTimeout(() => {
            setLoading(true);
            updateSearchValues("status", value);
            setCurrentPage(1);
          }, 0);
        }
        return true;
      },
      render: (val) => val || "",
    },
    {
      key: "salesPerson",
      title: "SALES PERSON",
      dataIndex: "salesPerson",
      ...getColumnSearchProps("salesPerson"),
    },
    {
      key: "managementFees",
      title: "MANAGEMENT FEES",
      dataIndex: "managementFees",
      render: (val) => (val ? `${val} EGP` : ""),
    },
  ];

  useEffect(() => {
    const payload = {
      pageNumber: currentPage,
      perPage: pageSize,
      ...searchValues,
    };
    for (let property in payload) {
      if (!payload[property] && payload[property] !== 0) {
        delete payload[property];
      }
    }

    setLoading(true);
    getCollectionsReceiptsForAdmin(
      payload,
      (res) => {
        if (res.success) {
          setDataSource(res.data.response);
          setTotalCount(res.data.totalCount);
        } else {
          toastError(res.message);
        }
        setLoading(false);
      },
      (error) => {
        toastError(error?.message || "Error fetching data");
        setLoading(false);
      }
    );
  }, [searchValues, currentPage, pageSize]);

  const handleExportDataToExcel = () => {
    if (isExporting) return;
    setIsExporting(true);

    const baseProps = [
      { title: "Name", prop: "fullName" },
      { title: "Mobile", prop: "phone" },
      { title: "Type", prop: "categoryName" },
      { title: "Sealed Quantity", prop: "sealedQuantity" },
      { title: "Offer Price", prop: "offeredPricePerKilo" },
      { title: "Commission", prop: "commission" },
      {
        title: "Total Price (Before Commission)",
        prop: "totalOfferPriceBeforeCommission",
      },
      {
        title: "Total Price (After Commission)",
        prop: "totalOfferPriceAfterCommission",
      },
      { title: "Selling Date", prop: "sellingDate" },
      { title: "Creation Date", prop: "creationDate" },
      { title: "Sales Person", prop: "salesPerson" },
      { title: "Management Fees", prop: "managementFees" },
    ];

    const payload = {
      isExport: true,
      currentPage,
      perPage: pageSize,
      ...searchValues,
    };

    for (let property in payload) {
      if (
        !payload[property] &&
        payload[property] !== 0 &&
        payload[property] !== false
      ) {
        delete payload[property];
      }
    }

    getCollectionsReceiptsForAdmin(
      payload,
      (res) => {
        if (res.success) {
          exportDataAsExcel(res.data.response, {
            baseProps,
            tab: "Received Confirmations Report",
          });
        } else {
          toastError(res.message);
          // still try to export if API sent data
          if (res.data?.response?.length) {
            exportDataAsExcel(res.data.response, {
              baseProps,
              tab: "Received Confirmations Report",
            });
          }
        }
        setIsExporting(false);
      },
      (err) => {
        toastError(err?.message || "Export failed");
        setIsExporting(false);
      }
    );
  };

  return (
    <section className="users received-confirmation">
      <div className="users__content">
        <Header title="Received Confirmations" />
        <SubHeader bgColor="#28a745" title="All Received Confirmations" />
        <GridTable
          loading={loading}
          columns={columns}
          dataSource={dataSource}
          rowId="purchaserequestId"
          title="Received Confirmations"
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={setCurrentPage}
          apiExport={true}
          allowExport={true}
          isExporting={isExporting}
          onExport={handleExportDataToExcel}
          pageSize={pageSize}
          onPageSizeChange={(_, newSize) => setPageSize(newSize)}
        />
      </div>
    </section>
  );
}

export default ReceivedConfirmation;
